import { createEntityAdapter } from '@reduxjs/toolkit';

export enum RemoteDesktopStatus {
  NOT_SUPPORTED = 'NOT_SUPPORTED',
  SUPPORTED_DISABLED = 'SUPPORTED_DISABLED',
  SUPPORTED_ENABLED = 'SUPPORTED_ENABLED',
}

export interface DeviceRemoteDesktopSupportResponse {
  deviceID: string;
  status: RemoteDesktopStatus;
  reason?: string;
}

export const DeviceRemoteDesktopAdapter =
  createEntityAdapter<DeviceRemoteDesktopSupportResponse>({
    selectId: (deviceStatus: DeviceRemoteDesktopSupportResponse) =>
      deviceStatus.deviceID,
  });
